// extracted by mini-css-extract-plugin
module.exports = {"related":"_2CKvzevWbl-PJ_FyuUYOmu","content":"_1nlAnhLJpggWuPEDJ8_UGj","heading":"s-UFhUPdS830b1D4tghH","body":"_1xRq1uZtliU9G-7JUqDUA4","grid":"_3xab167CGhdjEEZNvtmz3x"};